export const iconFontAwesomeHandsHandsHolding = (
	<i className="fa-solid fa-hands-holding"></i>
);
